module.exports = __webpack_public_path__ + "img/mexico-plata-bruxelles-2022.b7dd35aa.png";